export default __webpack_public_path__ + "static/media/299.9493e13d.png";